import * as React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import Banners from 'views/banners/Banners';

const banners= [    
  {
    title: "Unete al mundo digital.",
    subtitle: "Nuestra plataforma transforma la gestión de historiales médicos en un proceso ágil, seguro y moderno.", 
    image_url: "https://firebasestorage.googleapis.com/v0/b/xpediente-clinico.appspot.com/o/logos%2Fcardex_lleyow%20Large.png?alt=media&token=dcd1feaa-cf74-49bd-90c8-c5a627949057",
    color: "#ffffffff",
    background: "#1e1e1e",
    action:"www.xpendientemedico.com.mx →"
  }
]

export default function Hero() {
  const navigate = useNavigate();
  React.useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const onClickStart =()=>{
    navigate('/login');
  }

  return (
    <Container id = "main-banners" maxWidth={false} disableGutters component='main'>
      <Banners banners={banners}></Banners>
    </Container>
  );
}